<template>
  <SystemInsightsActionModal
    :allSystemsEligibleText="allSystemsEligibleText"
    continueText="disable"
    :eligibleCount="eligibleCount"
    eligibleDetailsText1=""
    eligibleDetailsText2=""
    headerText="Disable System Insights"
    :ineligibleSystems="getIneligibleSystems"
    :newState="newState"
    :noSystemsEligibleText="noSystemsEligibleText"
    :someSystemsEligibleText="someSystemsEligibleText"
    :warningText="warningText"
  />
</template>

<script>
import {
  ItemTypeConsts,
  StoreModuleMap,
  SystemInsightsConsts,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import SystemInsightsActionModal from 'components/Modal/SystemInsightsActionModal.vue';
import pluralize from 'pluralize';

const storeModule = StoreModuleMap[ItemTypeConsts.system];

export default {
  name: 'SystemInsightsDisableModal',

  components: {
    SystemInsightsActionModal,
  },

  data: () => ({
    newState: SystemInsightsConsts.systemState.deferred,
  }),

  computed: {
    ...mapGetters(storeModule, {
      getIneligibleSystems: 'getSystemsIneligibleForSystemInsightDisablement',
      selectedItems: 'getSelectedItems',
    }),

    allSystemsEligibleText() {
      return `You've selected **${pluralize('system', this.selectedCount, true)}** to disable for System Insights.`;
    },

    eligibleCount() {
      return this.selectedCount - this.getIneligibleSystems.length;
    },

    noSystemsEligibleText() {
      return 'No selected systems are enabled for System Insights.';
    },

    selectedCount() {
      return this.selectedItems.length;
    },

    someSystemsEligibleText() {
      return `${this.eligibleCount} of ${this.selectedCount} selected systems have System Insights enabled.`;
    },

    warningText() {
      return `When System Insights is disabled, additional information for the selected ${pluralize('system', this.eligibleCount)} will no longer be collected.  You will continue to have access to the last information that was collected before disabling.`;
    },
  },
};
</script>
